import {atom, selectorFamily} from 'recoil';
import {ToastHelpers} from '../../../shared/helpers/toastHelpers';
import {api} from '../../api';
import {createQuery} from '../../lib';

const {getDictsServiceTypesMy} = api.dicts;

const getDictsServiceTypesMyRefresh = atom<number>({
  key: 'getDictsServiceTypesMyRefresh',
  default: 0,
});

const getDictsServiceTypesMyQuery = selectorFamily({
  key: 'getDictsServiceTypesMy',
  get() {
    return async ({get}) => {
      get(getDictsServiceTypesMyRefresh);
      try {
        const {data} = await getDictsServiceTypesMy();
        return data;
      } catch (e) {
        ToastHelpers.error(e);
        throw e;
      }
    };
  },
});

export const useGetDictsServiceTypesMyQuery = createQuery(getDictsServiceTypesMyQuery, getDictsServiceTypesMyRefresh);
